/* rola.pet — kalkulator suchej masy karmy dla psa: silnik obliczeń + obsługa formularza.
   Zero zależności, zero zapytań sieciowych, dane nigdzie nie są wysyłane ani zapisywane.
   Działa z trybem quizu (rola-quiz.js) i bez niego.

   Metoda (zgodna z opisem FDA): sucha masa = 100 − wilgotność;
   składnik w suchej masie = wartość na etykiecie ÷ sucha masa × 100. */
(function(root){
  "use strict";

  var MJ_TO_KCAL = 239.005736;

  /* typy karm: domyślna wilgotność (gdy brak na etykiecie) i zakres typowy (tylko do ostrzeżeń) */
  var TYPES = [
    {k: "dry",   emoji: "\ud83e\udd63", name: "Karma sucha",          desc: "chrupki, granulat",              moisture: 10, typical: [0, 15],  label: "karma sucha"},
    {k: "wet",   emoji: "\ud83e\udd6b", name: "Karma mokra",          desc: "puszka, saszetka, pasztet",      moisture: 78, typical: [60, 90], label: "karma mokra"},
    {k: "semi",  emoji: "\ud83c\udf56", name: "Karma półwilgotna",    desc: "miękkie kawałki",                moisture: 30, typical: [15, 45], label: "karma półwilgotna"},
    {k: "fresh", emoji: "\ud83e\udd69", name: "Świeża lub gotowana",  desc: "z lodówki, mrożona, surowa",     moisture: 70, typical: [55, 80], label: "karma świeża lub gotowana"}
  ];
  var UNITS = {kcal_kg: "kcal/kg", kcal_100g: "kcal/100 g", mj_kg: "MJ/kg"};
  var NUTRIENTS = [
    {k: "protein", name: "Białko"},
    {k: "fat",     name: "Tłuszcz"},
    {k: "fiber",   name: "Włókno"},
    {k: "ash",     name: "Popiół"}
  ];

  function typeByKey(k){
    for(var i = 0; i < TYPES.length; i++) if(TYPES[i].k === k) return TYPES[i];
    return TYPES[0];
  }

  /* ================================================================
     POMOCNICZE
     ================================================================ */
  function fmt(n, dec){
    return Number(Number(n).toFixed(dec)).toLocaleString("pl-PL", {minimumFractionDigits: 0, maximumFractionDigits: dec});
  }
  function pct(n){ return fmt(n, 1) + "%"; }
  function parseNum(v){
    if(v === null || v === undefined) return null;
    var s = String(v).replace(",", ".").replace(/\s/g, "");
    if(s === "") return null;
    var n = parseFloat(s);
    return isFinite(n) ? n : null;
  }

  /* ================================================================
     SILNIK (czysta matematyka — te same wzory co w ТЗ)
     ================================================================ */
  function toKcalPerKg(value, unit){
    if(unit === "kcal_kg") return value;
    if(unit === "kcal_100g") return value * 10;
    if(unit === "mj_kg") return value * MJ_TO_KCAL;
    return null;
  }

  /* food: {moisture, protein, fat, fiber|null, ash|null, energy: {value, unit}|null} */
  function calc(food){
    var dm = 100 - food.moisture;
    var r = {dm: dm, moisture: food.moisture, nutrients: {}, carbs: null, energy: null};
    NUTRIENTS.forEach(function(n){
      var v = food[n.k];
      if(v !== null && v !== undefined) r.nutrients[n.k] = {asFed: v, dm: v / dm * 100};
    });
    /* węglowodany „z różnicy” — tylko gdy są wszystkie składniki */
    if(food.protein != null && food.fat != null && food.fiber != null && food.ash != null){
      var c = 100 - food.moisture - food.protein - food.fat - food.fiber - food.ash;
      if(c >= 0) r.carbs = {asFed: c, dm: c / dm * 100};
    }
    if(food.energy && food.energy.value != null){
      var kcalKg = toKcalPerKg(food.energy.value, food.energy.unit);
      if(kcalKg !== null){
        var k100 = kcalKg / 10;
        r.energy = {
          value: food.energy.value, unit: food.energy.unit,
          kcalKg: kcalKg, kcal100: k100,
          kcal100Dm: k100 / (dm / 100), kcalKgDm: kcalKg / (dm / 100)
        };
      }
    }
    return r;
  }

  root.RolaDryMatterEngine = {calc: calc, toKcalPerKg: toKcalPerKg, parseNum: parseNum, TYPES: TYPES};

  if(typeof document === "undefined") return;

  /* ================================================================
     FORMULARZ
     ================================================================ */
  function init(rootEl){
    var $ = function(s){ return rootEl.querySelector(s); };
    var $$ = function(s){ return Array.prototype.slice.call(rootEl.querySelectorAll(s)); };
    var scope = rootEl.closest("[data-rc-scope]") || rootEl.parentNode;
    var uid = Math.random().toString(36).slice(2, 7);

    var el = {
      types: $("[data-d-types]"),
      protein: $("[data-d-protein]"), fat: $("[data-d-fat]"), fiber: $("[data-d-fiber]"),
      ash: $("[data-d-ash]"), moisture: $("[data-d-moisture]"), moistureHint: $("[data-d-moisture-hint]"),
      energy: $("[data-d-energy]"), unit: $("[data-d-unit]"), name: $("[data-d-name]"),
      banner: $("[data-d-banner]"),
      content: $("[data-d-content]"), empty: $("[data-d-empty]"),
      single: $("[data-d-single]"), compare: $("[data-d-compare]"),
      table: $("[data-d-table]"), cmpTable: $("[data-d-cmp-table]"),
      warns: $("[data-d-warns]"), note: $("[data-d-note]"),
      cmpBtn: $("[data-d-cmp]"), clearBtn: $("[data-d-clear]"), share: $("[data-d-share]"), toast: $("[data-d-toast]")
    };
    var foodA = null;       /* zapisana karma A (do porównania) */
    var lastView = null;

    /* karty typów karmy (z konfiguracji powyżej) */
    TYPES.forEach(function(t, i){
      var lab = document.createElement("label");
      lab.className = "rc-opt" + (i === 0 ? " is-on" : "");
      var input = document.createElement("input");
      input.type = "radio"; input.name = "rd-type-" + uid; input.value = t.k; input.setAttribute("data-d-type", "");
      if(i === 0) input.checked = true;
      var wrap = document.createElement("span"); wrap.className = "rc-opt-in";
      var em = document.createElement("span"); em.className = "rc-opt-emoji"; em.setAttribute("aria-hidden", "true"); em.textContent = t.emoji;
      var txt = document.createElement("span"); txt.className = "rc-opt-txt";
      var nm = document.createElement("span"); nm.className = "rc-opt-name"; nm.textContent = t.name;
      var ds = document.createElement("span"); ds.className = "rc-opt-desc"; ds.textContent = t.desc;
      txt.appendChild(nm); txt.appendChild(ds); wrap.appendChild(em); wrap.appendChild(txt);
      lab.appendChild(input); lab.appendChild(wrap);
      el.types.appendChild(lab);
    });

    function typeKey(){
      var r = $$("[data-d-type]").filter(function(x){ return x.checked; })[0];
      return r ? r.value : "dry";
    }

    /* ---------- odczyt i walidacja ---------- */
    function fail(msg, node){ return {ok: false, msg: msg, el: node}; }

    function readNutrient(node, label, required){
      var raw = String(node.value).trim();
      if(raw === ""){
        return required ? fail("Wpisz zawartość: " + label + " (z tabeli „Składniki analityczne” na opakowaniu).", node) : {ok: true, v: null};
      }
      var v = parseNum(raw);
      if(v === null || v < 0) return fail("Podaj poprawną wartość procentową dla: " + label + ".", node);
      if(v > 100) return fail("Wartość nie może przekraczać 100% (" + label + "). Sprawdź, czy nie pomylono kolumn.", node);
      if(required && v === 0) return fail("Wpisz zawartość: " + label + ".", node);
      return {ok: true, v: v};
    }

    function readFood(){
      var t = typeByKey(typeKey());
      var out = {typeKey: t.k, type: t, name: String(el.name.value || "").trim()};

      var mRaw = String(el.moisture.value).trim();
      if(mRaw === ""){
        out.moisture = t.moisture; out.moistureAssumed = true;
      } else {
        var m = parseNum(mRaw);
        if(m === null || m <= 0 || m >= 100) return fail("Wilgotność musi być większa od 0% i mniejsza niż 100%.", el.moisture);
        out.moisture = m; out.moistureAssumed = false;
      }

      var p = readNutrient(el.protein, "białko", true); if(!p.ok) return p;
      var f = readNutrient(el.fat, "tłuszcz", true); if(!f.ok) return f;
      var fi = readNutrient(el.fiber, "włókno", false); if(!fi.ok) return fi;
      var a = readNutrient(el.ash, "popiół", false); if(!a.ok) return a;
      out.protein = p.v; out.fat = f.v; out.fiber = fi.v; out.ash = a.v;

      var sum = out.moisture + out.protein + out.fat + (out.fiber || 0) + (out.ash || 0);
      if(sum > 100.5){
        return fail("Suma wpisanych składników (" + fmt(sum, 1) + "%) przekracza 100%. Sprawdź wartości i wilgotność.", el.protein);
      }

      out.energy = null;
      var eRaw = String(el.energy.value).trim();
      if(eRaw !== ""){
        var ev = parseNum(eRaw);
        if(ev === null || ev <= 0) return fail("Podaj energię jako liczbę większą od zera albo zostaw pole puste.", el.energy);
        var k100 = toKcalPerKg(ev, el.unit.value) / 10;
        if(k100 < 10 || k100 > 700){
          return fail("Ta energia wygląda nietypowo (" + fmt(k100, 0) + " kcal/100 g). Sprawdź jednostkę — typowa karma sucha ma 330–420 kcal/100 g (3300–4200 kcal/kg).", el.energy);
        }
        out.energy = {value: ev, unit: el.unit.value};
      }
      out.ok = true;
      return out;
    }

    /* haki dla trybu quizu: walidacja kroku przed przejściem dalej */
    var steps = {};
    $$("[data-d-step]").forEach(function(s){ steps[s.getAttribute("data-d-step")] = s; });
    if(steps.data) steps.data.rqValidate = function(){
      var r = readFood();
      return r.ok ? true : {msg: r.msg, el: r.el};
    };

    /* ---------- ostrzeżenia ---------- */
    function warningsFor(food, res){
      var w = [];
      var t = food.type;
      if(food.moistureAssumed){
        w.push({hard: false, text: "Na etykiecie nie podano wilgotności, więc przyjęto " + t.moisture + "% — wartość typową dla tego rodzaju karmy. Jeśli znasz dokładną wilgotność, wpisz ją, a wynik będzie pewniejszy."});
      } else if(food.moisture < t.typical[0] || food.moisture > t.typical[1]){
        w.push({hard: false, text: "Wilgotność " + fmt(food.moisture, 1) + "% jest nietypowa dla rodzaju „" + t.label + "” (zwykle " + t.typical[0] + "–" + t.typical[1] + "%). Sprawdź, czy wybrano właściwy rodzaj karmy i czy wartość jest poprawna."});
      }
      if(food.fiber === null || food.ash === null){
        w.push({hard: false, text: "Nie podano " + (food.fiber === null && food.ash === null ? "włókna ani popiołu" : (food.fiber === null ? "włókna" : "popiołu")) + ", więc nie szacujemy węglowodanów."});
      } else if(food.moistureAssumed){
        w.push({hard: false, text: "Szacunek węglowodanów opiera się na przyjętej wilgotności, więc traktuj go bardzo orientacyjnie."});
      }
      if(res.energy && (res.energy.kcal100 < 20 || res.energy.kcal100 > 600)){
        w.push({hard: false, text: "Energia " + fmt(res.energy.kcal100, 0) + " kcal/100 g jest nietypowa — sprawdź jednostkę."});
      }
      return w;
    }

    /* ---------- tabele ---------- */
    function cell(tag, text, cls){
      var c = document.createElement(tag);
      if(cls) c.className = cls;
      c.textContent = text;
      return c;
    }
    function tr(cells, cls){
      var r = document.createElement("tr");
      if(cls) r.className = cls;
      cells.forEach(function(c){ r.appendChild(c); });
      return r;
    }
    function dash(v, f){ return v === null || v === undefined ? "—" : f(v); }

    function renderSingle(food, res){
      el.table.innerHTML = "";
      var thead = document.createElement("thead");
      thead.appendChild(tr([cell("th", "Składnik"), cell("th", "Na etykiecie"), cell("th", "W suchej masie")]));
      el.table.appendChild(thead);
      var tb = document.createElement("tbody");
      tb.appendChild(tr([cell("th", "Wilgotność"), cell("td", pct(res.moisture) + (food.moistureAssumed ? " (przyjęto)" : "")), cell("td", "—")]));
      NUTRIENTS.forEach(function(n){
        var x = res.nutrients[n.k];
        tb.appendChild(tr([cell("th", n.name), cell("td", x ? pct(x.asFed) : "—"), cell("td", x ? pct(x.dm) : "—", "rd-dm")]));
      });
      if(res.carbs){
        tb.appendChild(tr([cell("th", "Węglowodany (szacunek)"), cell("td", pct(res.carbs.asFed)), cell("td", pct(res.carbs.dm), "rd-dm")]));
      }
      if(res.energy){
        tb.appendChild(tr([cell("th", "Energia"), cell("td", fmt(res.energy.kcal100, 0) + " kcal/100 g"), cell("td", fmt(res.energy.kcal100Dm, 0) + " kcal/100 g s.m.", "rd-dm")]));
      }
      el.table.appendChild(tb);

      $("[data-d-dm]").textContent = pct(res.dm);
      $("[data-d-dm-unit]").textContent = "sucha masa · wilgotność " + pct(res.moisture) + (food.moistureAssumed ? " (przyjęta)" : "");
      var head = (food.name || "Ta karma") + " · " + food.type.label;
      $("[data-d-headline]").textContent = head + " · dane wpisane ręcznie";
      var en = $("[data-d-energy-note]");
      if(res.energy){
        var u = UNITS[res.energy.unit];
        en.textContent = "Energia: " + fmt(res.energy.value, res.energy.unit === "mj_kg" ? 1 : 0) + " " + u + " = " + fmt(res.energy.kcal100, 0) + " kcal/100 g na etykiecie, czyli " + fmt(res.energy.kcal100Dm, 0) + " kcal/100 g w suchej masie.";
        en.hidden = false;
      } else {
        en.hidden = true;
      }
    }

    function nameOf(f, fallback){ return f.name || fallback; }

    function renderCompare(a, b){
      var A = a.res, B = b.res;
      var nameA = nameOf(a.food, "Karma A"), nameB = nameOf(b.food, "Karma B");
      $("[data-d-dm-a]").textContent = pct(A.dm);
      $("[data-d-dm-b]").textContent = pct(B.dm);
      $("[data-d-name-a]").textContent = nameA + " · sucha masa";
      $("[data-d-name-b]").textContent = nameB + " · sucha masa";

      el.cmpTable.innerHTML = "";
      var thead = document.createElement("thead");
      thead.appendChild(tr([cell("th", ""), cell("th", nameA), cell("th", nameB)]));
      el.cmpTable.appendChild(thead);
      var tb = document.createElement("tbody");
      function add(label, va, vb, strong){
        if(va === "—" && vb === "—") return;
        tb.appendChild(tr([cell("th", label), cell("td", va, strong ? "rd-dm" : ""), cell("td", vb, strong ? "rd-dm" : "")]));
      }
      add("Rodzaj karmy", a.food.type.label, b.food.type.label);
      add("Wilgotność", pct(A.moisture) + (a.food.moistureAssumed ? " (przyjęto)" : ""), pct(B.moisture) + (b.food.moistureAssumed ? " (przyjęto)" : ""));
      add("Sucha masa", pct(A.dm), pct(B.dm));
      NUTRIENTS.forEach(function(n){
        var xa = A.nutrients[n.k], xb = B.nutrients[n.k];
        add(n.name + " — na etykiecie", dash(xa, function(x){ return pct(x.asFed); }), dash(xb, function(x){ return pct(x.asFed); }));
        add(n.name + " — w suchej masie", dash(xa, function(x){ return pct(x.dm); }), dash(xb, function(x){ return pct(x.dm); }), true);
      });
      add("Węglowodany (szacunek) — w suchej masie", dash(A.carbs, function(x){ return pct(x.dm); }), dash(B.carbs, function(x){ return pct(x.dm); }), true);
      add("Energia — na etykiecie", dash(A.energy, function(x){ return fmt(x.kcal100, 0) + " kcal/100 g"; }), dash(B.energy, function(x){ return fmt(x.kcal100, 0) + " kcal/100 g"; }));
      add("Energia — w suchej masie", dash(A.energy, function(x){ return fmt(x.kcal100Dm, 0) + " kcal/100 g s.m."; }), dash(B.energy, function(x){ return fmt(x.kcal100Dm, 0) + " kcal/100 g s.m."; }), true);
      el.cmpTable.appendChild(tb);
    }

    /* ---------- render ---------- */
    function warn(text, hard){
      var d = document.createElement("div");
      d.className = "rc-warn" + (hard ? " rc-warn--hard" : "");
      d.textContent = text;
      el.warns.appendChild(d);
    }

    function render(){
      var cur = readFood();
      var ok = cur.ok;
      /* baner przy porównaniu */
      if(foodA){
        el.banner.textContent = "Porównujesz z: " + nameOf(foodA.food, "Karma A") + ". Wpisz dane drugiej karmy.";
        el.banner.hidden = false;
      } else {
        el.banner.hidden = true;
      }

      /* podpowiedź przy wilgotności */
      var t = typeByKey(typeKey());
      el.moisture.placeholder = "np. " + (t.k === "dry" ? "8" : t.moisture);
      el.moistureHint.textContent = "Nie ma jej na opakowaniu? Zostaw puste — przyjmiemy " + t.moisture + "% (typowe dla rodzaju „" + t.label + "”).";

      if(!ok){
        el.content.hidden = true;
        el.empty.textContent = foodA ? "Uzupełnij dane drugiej karmy, aby zobaczyć porównanie." : "Uzupełnij dane karmy powyżej, aby zobaczyć wynik.";
        el.empty.hidden = false;
        lastView = null;
        return;
      }
      el.content.hidden = false; el.empty.hidden = true;
      el.warns.innerHTML = "";

      var res = calc(cur);
      var compareMode = !!foodA;
      el.single.hidden = compareMode;
      el.compare.hidden = !compareMode;
      el.cmpBtn.hidden = compareMode;
      el.clearBtn.hidden = !compareMode;

      var warnings = warningsFor(cur, res);
      if(compareMode){
        var aRes = foodA.res;
        renderCompare(foodA, {food: cur, res: res});
        warningsFor(foodA.food, aRes).forEach(function(w){ warn(nameOf(foodA.food, "Karma A") + ": " + w.text, w.hard); });
        warnings.forEach(function(w){ warn(nameOf(cur, "Karma B") + ": " + w.text, w.hard); });
        el.note.textContent = "Karmę można porównać dopiero po przeliczeniu na suchą masę. Wyższy wynik białka nie oznacza automatycznie, że produkt jest lepszy dla każdego psa. To porównanie składu, a nie rekomendacja weterynaryjna.";
        lastView = {mode: "compare", a: foodA, b: {food: cur, res: res}};
      } else {
        renderSingle(cur, res);
        warnings.forEach(function(w){ warn(w.text, w.hard); });
        el.note.textContent = "Wartości w suchej masie pozwalają porównać karmy o różnej wilgotności — np. puszkę (ok. 78% wody) z karmą suchą (ok. 10%). Samo to, że jakiś składnik jest wyższy, nie mówi jeszcze, że karma jest lepsza.";
        lastView = {mode: "single", a: {food: cur, res: res}};
      }
      publish(cur, res);
    }

    function publish(food, res){
      if(!scope || !scope.setAttribute) return;
      try {
        scope.setAttribute("data-rc-params", JSON.stringify({
          kalkulator: "sucha_masa", tryb: foodA ? "porownanie" : "pojedyncza",
          rodzaj: food.type.label, wilgotnosc: food.moisture, wilgotnosc_przyjeta: food.moistureAssumed,
          sucha_masa: res.dm,
          bialko_sm: res.nutrients.protein ? Math.round(res.nutrients.protein.dm * 10) / 10 : null,
          tluszcz_sm: res.nutrients.fat ? Math.round(res.nutrients.fat.dm * 10) / 10 : null
        }));
      } catch(e){}
      var slots = scope.querySelectorAll("[data-rc-stage-name]");
      for(var i = 0; i < slots.length; i++) slots[i].textContent = food.type.label;
      scope.setAttribute("data-rc-stage", food.type.label);
    }

    /* ---------- porównanie dwóch karm ---------- */
    function resetForm(){
      ["protein", "fat", "fiber", "ash", "moisture", "energy", "name"].forEach(function(k){ el[k].value = ""; });
      var first = $$("[data-d-type]")[0];
      if(first){ first.checked = true; $$(".rc-opt").forEach(function(o){ var i = o.querySelector("input[type=radio]"); if(i) o.classList.toggle("is-on", i.checked); }); }
    }

    function fireRestart(){
      var ev;
      try { ev = new CustomEvent("rq:restart", {bubbles: true}); }
      catch(e){ ev = document.createEvent("CustomEvent"); ev.initCustomEvent("rq:restart", true, false, null); }
      scope.dispatchEvent(ev);
    }

    el.cmpBtn.addEventListener("click", function(){
      var cur = readFood();
      if(!cur.ok) return;
      foodA = {food: cur, res: calc(cur)};
      if(window.dataLayer) window.dataLayer.push({event: "rola_calc_compare_start", rola_feature: "drymatter_calculator"});
      resetForm();
      render();
      fireRestart();
      if(!scope.hasAttribute("data-quiz")){
        var r = rootEl.getBoundingClientRect();
        window.scrollTo({top: window.pageYOffset + r.top - 100, behavior: "smooth"});
      }
    });
    el.clearBtn.addEventListener("click", function(){
      foodA = null;
      render();
    });

    /* ---------- udostępnianie ---------- */
    function toast(msg){
      if(!el.toast) return;
      el.toast.textContent = msg; el.toast.hidden = false;
      clearTimeout(toast._t);
      toast._t = setTimeout(function(){ el.toast.hidden = true; }, 3500);
    }
    function shareText(){
      if(!lastView) return "";
      function one(x){
        var n = nameOf(x.food, "Karma"), r = x.res, parts = [n + ": sucha masa " + pct(r.dm)];
        if(r.nutrients.protein) parts.push("białko " + pct(r.nutrients.protein.asFed) + " → " + pct(r.nutrients.protein.dm) + " s.m.");
        if(r.nutrients.fat) parts.push("tłuszcz " + pct(r.nutrients.fat.asFed) + " → " + pct(r.nutrients.fat.dm) + " s.m.");
        return parts.join(", ");
      }
      if(lastView.mode === "compare") return "Porównanie karm na suchej masie (rola.pet). " + one(lastView.a) + ". " + one(lastView.b) + ".";
      return "Kalkulator suchej masy karmy (rola.pet). " + one(lastView.a) + ".";
    }
    if(el.share) el.share.addEventListener("click", function(){
      var text = shareText();
      if(!text) return;
      var url = location.href.split("#")[0];
      if(window.dataLayer) window.dataLayer.push({event: "rola_calc_share", rola_feature: "drymatter_calculator"});
      if(navigator.share){
        navigator.share({title: "Wynik: sucha masa karmy", text: text, url: url}).catch(function(){});
        return;
      }
      var full = text + " " + url;
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(full).then(function(){ toast("Skopiowano wynik do schowka."); }, function(){ window.prompt("Skopiuj wynik:", full); });
      } else {
        window.prompt("Skopiuj wynik:", full);
      }
    });

    /* ---------- zdarzenia ---------- */
    rootEl.addEventListener("input", render);
    rootEl.addEventListener("change", function(){
      $$(".rc-opt").forEach(function(o){
        var inp = o.querySelector("input[type=radio]");
        if(inp) o.classList.toggle("is-on", inp.checked);
      });
      render();
    });

    render();
  }

  function boot(){
    var nodes = document.querySelectorAll("[data-rola-dog-drymatter]");
    for(var i = 0; i < nodes.length; i++){
      if(nodes[i].getAttribute("data-rc-init")) continue;
      nodes[i].setAttribute("data-rc-init", "1");
      init(nodes[i]);
    }
  }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})(typeof window !== "undefined" ? window : this);
